"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _MediaItemInstance = _interopRequireDefault(require("./MediaItemInstance"));
var _MediaSubscription = _interopRequireDefault(require("./MediaSubscription"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The MediaSubscriptionInstance model module.
 * @module model/MediaSubscriptionInstance
 * @version 3.0
 */
var MediaSubscriptionInstance = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>MediaSubscriptionInstance</code>.
   * @alias module:model/MediaSubscriptionInstance
   */
  function MediaSubscriptionInstance() {
    _classCallCheck(this, MediaSubscriptionInstance);
    MediaSubscriptionInstance.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(MediaSubscriptionInstance, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>MediaSubscriptionInstance</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MediaSubscriptionInstance} obj Optional instance to populate.
     * @return {module:model/MediaSubscriptionInstance} The populated <code>MediaSubscriptionInstance</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new MediaSubscriptionInstance();
        if (data.hasOwnProperty('instanceId')) {
          obj['instanceId'] = _ApiClient["default"].convertToType(data['instanceId'], 'Number');
        }
        if (data.hasOwnProperty('instanceLegacyId')) {
          obj['instanceLegacyId'] = _ApiClient["default"].convertToType(data['instanceLegacyId'], 'String');
        }
        if (data.hasOwnProperty('startDateTime')) {
          obj['startDateTime'] = _ApiClient["default"].convertToType(data['startDateTime'], 'Date');
        }
        if (data.hasOwnProperty('expiryDateTime')) {
          obj['expiryDateTime'] = _ApiClient["default"].convertToType(data['expiryDateTime'], 'Date');
        }
        if (data.hasOwnProperty('removable')) {
          obj['removable'] = _ApiClient["default"].convertToType(data['removable'], 'Boolean');
        }
        if (data.hasOwnProperty('productId')) {
          obj['productId'] = _ApiClient["default"].convertToType(data['productId'], 'Number');
        }
        if (data.hasOwnProperty('upfrontCost')) {
          obj['upfrontCost'] = _ApiClient["default"].convertToType(data['upfrontCost'], 'Number');
        }
        if (data.hasOwnProperty('recurringCost')) {
          obj['recurringCost'] = _ApiClient["default"].convertToType(data['recurringCost'], 'Number');
        }
        if (data.hasOwnProperty('costUnit')) {
          obj['costUnit'] = _ApiClient["default"].convertToType(data['costUnit'], 'String');
        }
        if (data.hasOwnProperty('currency')) {
          obj['currency'] = _ApiClient["default"].convertToType(data['currency'], 'String');
        }
        if (data.hasOwnProperty('purchasedDateTime')) {
          obj['purchasedDateTime'] = _ApiClient["default"].convertToType(data['purchasedDateTime'], 'Date');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('category')) {
          obj['category'] = _ApiClient["default"].convertToType(data['category'], 'String');
        }
        if (data.hasOwnProperty('additionalInformation')) {
          obj['additionalInformation'] = _ApiClient["default"].convertToType(data['additionalInformation'], 'String');
        }
        if (data.hasOwnProperty('product')) {
          obj['product'] = _MediaSubscription["default"].constructFromObject(data['product']);
        }
        if (data.hasOwnProperty('mediaItemInstances')) {
          obj['mediaItemInstances'] = _ApiClient["default"].convertToType(data['mediaItemInstances'], [_MediaItemInstance["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MediaSubscriptionInstance</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MediaSubscriptionInstance</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['instanceLegacyId'] && !(typeof data['instanceLegacyId'] === 'string' || data['instanceLegacyId'] instanceof String)) {
        throw new Error("Expected the field `instanceLegacyId` to be a primitive type in the JSON string but got " + data['instanceLegacyId']);
      }
      // ensure the json data is a string
      if (data['costUnit'] && !(typeof data['costUnit'] === 'string' || data['costUnit'] instanceof String)) {
        throw new Error("Expected the field `costUnit` to be a primitive type in the JSON string but got " + data['costUnit']);
      }
      // ensure the json data is a string
      if (data['currency'] && !(typeof data['currency'] === 'string' || data['currency'] instanceof String)) {
        throw new Error("Expected the field `currency` to be a primitive type in the JSON string but got " + data['currency']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      // ensure the json data is a string
      if (data['category'] && !(typeof data['category'] === 'string' || data['category'] instanceof String)) {
        throw new Error("Expected the field `category` to be a primitive type in the JSON string but got " + data['category']);
      }
      // ensure the json data is a string
      if (data['additionalInformation'] && !(typeof data['additionalInformation'] === 'string' || data['additionalInformation'] instanceof String)) {
        throw new Error("Expected the field `additionalInformation` to be a primitive type in the JSON string but got " + data['additionalInformation']);
      }
      // validate the optional field `product`
      if (data['product']) {
        // data not null
        _MediaSubscription["default"].validateJSON(data['product']);
      }
      if (data['mediaItemInstances']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['mediaItemInstances'])) {
          throw new Error("Expected the field `mediaItemInstances` to be an array in the JSON data but got " + data['mediaItemInstances']);
        }
        // validate the optional field `mediaItemInstances` (array)
        var _iterator = _createForOfIteratorHelper(data['mediaItemInstances']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _MediaItemInstance["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} instanceId
 */
MediaSubscriptionInstance.prototype['instanceId'] = undefined;

/**
 * @member {String} instanceLegacyId
 */
MediaSubscriptionInstance.prototype['instanceLegacyId'] = undefined;

/**
 * @member {Date} startDateTime
 */
MediaSubscriptionInstance.prototype['startDateTime'] = undefined;

/**
 * @member {Date} expiryDateTime
 */
MediaSubscriptionInstance.prototype['expiryDateTime'] = undefined;

/**
 * @member {Boolean} removable
 */
MediaSubscriptionInstance.prototype['removable'] = undefined;

/**
 * @member {Number} productId
 */
MediaSubscriptionInstance.prototype['productId'] = undefined;

/**
 * @member {Number} upfrontCost
 */
MediaSubscriptionInstance.prototype['upfrontCost'] = undefined;

/**
 * @member {Number} recurringCost
 */
MediaSubscriptionInstance.prototype['recurringCost'] = undefined;

/**
 * @member {String} costUnit
 */
MediaSubscriptionInstance.prototype['costUnit'] = undefined;

/**
 * @member {String} currency
 */
MediaSubscriptionInstance.prototype['currency'] = undefined;

/**
 * @member {Date} purchasedDateTime
 */
MediaSubscriptionInstance.prototype['purchasedDateTime'] = undefined;

/**
 * @member {String} status
 */
MediaSubscriptionInstance.prototype['status'] = undefined;

/**
 * @member {String} category
 */
MediaSubscriptionInstance.prototype['category'] = undefined;

/**
 * @member {String} additionalInformation
 */
MediaSubscriptionInstance.prototype['additionalInformation'] = undefined;

/**
 * @member {module:model/MediaSubscription} product
 */
MediaSubscriptionInstance.prototype['product'] = undefined;

/**
 * @member {Array.<module:model/MediaItemInstance>} mediaItemInstances
 */
MediaSubscriptionInstance.prototype['mediaItemInstances'] = undefined;
var _default = exports["default"] = MediaSubscriptionInstance;